import { render, staticRenderFns } from "./TosContent.vue?vue&type=template&id=b1dc4408&scoped=true"
var script = {}
import style0 from "./TosContent.vue?vue&type=style&index=0&id=b1dc4408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc4408",
  null
  
)

export default component.exports